import s from './Container.module.scss';
const Container = ({ children, isFullWidth, className, size = '' }) => {
  return (
    <div
      className={`${s.container} ${isFullWidth ? s.fullWidth : ''} ${s[size]} ${className}`}
    >
      {children}
    </div>
  );
};

export default Container;
